import { apiCall } from './gqlClient';

const GETZOOMUSER_QUERY = `
  query getZoomUser {
    getZoomUser
  }`;

export const getZoomUserApiCall = async () => apiCall({ query: GETZOOMUSER_QUERY, variables: {}});

const GENERATEZOOMMEETING_QUERY = `
  query generateZoomMeeting {
    generateZoomMeeting
  }`;

export const generateZoomMeetingApiCall = async () => apiCall({ query: GENERATEZOOMMEETING_QUERY, variables: {}});

const GETLATESTZOOMMEETINGURL_QUERY = `
  query getLatestZoomMeetingUrl {
    getLatestZoomMeetingUrl
  }`;

export const getLatestZoomMeetingUrlApiCall = async () => apiCall({ query: GETLATESTZOOMMEETINGURL_QUERY, variables: {}});

const ZOOMCHECKIFPROVIDERCONNECTED_QUERY = `
  query zoomCheckIfProviderConnected {
    zoomCheckIfProviderConnected
  }`;

export const zoomCheckIfProviderConnectedApiCall = async () => apiCall({ query: ZOOMCHECKIFPROVIDERCONNECTED_QUERY, variables: {}});

const DISCONNECTZOOM_QUERY = `
  mutation disconnectZoom {
    disconnectZoom
  }`;

export const disconnectZoomApiCall = async () => apiCall({ query: DISCONNECTZOOM_QUERY, variables: {}});
